import React, { useEffect, useState } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import axios from 'axios';

const Top10StockOutBarChart = () => {
  const [data, setData] = useState([]);
  const API = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API}/analytics/top10-stockout-this-month`, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });
        setData(res.data);
      } catch (error) {
        console.error('Error fetching top 10 stock out:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="w-full h-[300px]">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="vertical" >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" className="text-sm"/>
          <YAxis dataKey="product_name" type="category" className="text-sm"/>
          <Tooltip />
          <Legend />
          <Bar dataKey="total_out" fill="#FF8042" name="Qty Out" className="text-sm"/>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Top10StockOutBarChart;
